import HBox from '@/components/layout/HBox';
import IconeCanal from '@/components/layout/IconeCanal';
import IconeTipoContato from '@/components/layout/IconeTipoContato';

export const contatoTipoOptions = [
  {
    id: 'telefone',
    label: (
      <HBox>
        <IconeCanal tipo="voip" style={{ height: '16px' }} />
        Telefone
      </HBox>
    ),
  },
  {
    id: 'whatsapp',
    label: (
      <HBox>
        <IconeCanal tipo="whatsapp" style={{ height: '16px' }} />
        WhatsApp
      </HBox>
    ),
  },
  {
    id: 'whatsapp_bsuid',
    label: (
      <HBox>
        <IconeTipoContato tipo="whatsapp_bsuid" style={{ height: '16px' }} />
        WhatsApp (BSUID)
      </HBox>
    ),
  },
  {
    id: 'whatsapp_username',
    label: (
      <HBox>
        <IconeTipoContato tipo="whatsapp_username" style={{ height: '16px' }} />
        WhatsApp (usuário)
      </HBox>
    ),
  },
  {
    id: 'telegram',
    label: (
      <HBox>
        <IconeCanal tipo="telegram" style={{ height: '16px' }} />
        Telegram
      </HBox>
    ),
  },
  {
    id: 'email',
    label: (
      <HBox>
        <IconeCanal tipo="email" style={{ height: '16px' }} />
        E-mail
      </HBox>
    ),
  },
  {
    id: 'webchat',
    label: (
      <HBox>
        <IconeCanal tipo="webchat" style={{ height: '16px' }} />
        Webchat
      </HBox>
    ),
  },
];
